import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
import { offer } from '../data/offer';
export function Footer() {
  return <footer className="border-t border-line bg-ink px-5 py-12" data-id="element-85" data-mp="3ggty8ibanj58">
      <div className="mx-auto max-w-4xl text-center" data-id="element-86" data-mp="32oe1fz8zkhcr">
        <div className="flex flex-col items-center justify-center gap-3 text-sm font-bold text-cream sm:flex-row sm:gap-8" data-id="element-87" data-mp="32lrlbb814tix">
          <a href={`mailto:${offer.email}`} className="flex items-center gap-2 hover:text-brand" data-id="element-88" data-mp="3uf0md6qfy4rp">
            <MailIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-89" data-mp="38qyt7e9m7ve" />
            {offer.email}
          </a>
          <a href={`https://${offer.domain}`} className="flex items-center gap-2 hover:text-brand" data-id="element-90" data-mp="3levgj10wbefn">
            <GlobeIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-91" data-mp="3qcx9qes1cu4u" />
            {offer.domain}
          </a>
        </div>
        {offer.socials.length > 0 && <ul className="mt-5 flex justify-center gap-5 text-sm font-bold text-muted" data-id="element-92" data-mp="2a1jjb8zn5u2g">
            {offer.socials.map(s => <li key={s.url} data-id="element-93" data-mp="3l90n1twdyuy7">
                <a href={s.url} className="hover:text-white" data-id="element-94" data-mp="3labt60db0esh">{s.label}</a>
              </li>)}
          </ul>}
        <p className="mt-8 text-sm text-muted" data-id="element-95" data-mp="3gcjw6rxsy2hf">© ReadyKit Digital™ 2026 — Todos los derechos reservados.</p>
        <p className="mt-1 text-xs text-muted/70" data-id="element-96" data-mp="3v5dhitzr9cu0">
          Prohibida la reproducción comercial, reventa y redistribución sin autorización expresa.
        </p>
        <p className="mt-6 text-sm font-semibold italic text-cream/80" data-id="element-97" data-mp="81foxu0vmo35">
          Porque disfrutar en familia no debería requerir horas buscando qué hacer.
        </p>
      </div>
    </footer>;
}